// apps/web/src/components/tools/ToolsManager.tsx
// Tools and utilities management component

import { useState } from 'react';

export function ToolsManager() {
  const [activeTool, setActiveTool] = useState<string | null>(null);

  const tools = [
    { id: 'budget-calculator', name: 'Budget Calculator', description: 'Calculate campaign budgets' },
    { id: 'rate-calculator', name: 'Rate Calculator', description: 'Calculate creator rates' },
    { id: 'export', name: 'Data Export', description: 'Export platform data' },
    { id: 'import', name: 'Data Import', description: 'Import external data' },
    { id: 'backup', name: 'Backup Manager', description: 'Manage system backups' },
    { id: 'comparisons', name: 'Creator Comparisons', description: 'Compare creator performance' },
  ];

  const handleToolSelect = (toolId: string) => {
    setActiveTool(toolId === activeTool ? null : toolId);
  };

  return (
    <div className="tools-manager">
      <div className="header">
        <h2>Platform Tools & Utilities</h2>
      </div>

      <div className="tools-grid">
        {tools.map(tool => (
          <ToolCard 
            key={tool.id} 
            tool={tool} 
            isActive={activeTool === tool.id}
            onSelect={handleToolSelect}
          />
        ))}
      </div>

      {activeTool && (
        <div className="tool-details">
          <h3>{tools.find(t => t.id === activeTool)?.name} Details</h3>
          <p>{tools.find(t => t.id === activeTool)?.description}</p>
          <div className="tool-actions">
            <button className="btn btn-primary">Launch Tool</button>
            <button className="btn btn-secondary">Documentation</button>
          </div>
        </div>
      )}
    </div>
  );
}

// Helper component
function ToolCard({ tool, isActive, onSelect }: { 
  tool: any; 
  isActive: boolean; 
  onSelect: (id: string) => void 
}) {
  return (
    <div 
      className={`tool-card ${isActive ? 'active' : ''}`}
      role="button"
      tabIndex={0}
      onClick={() => onSelect(tool.id)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') onSelect(tool.id);
      }}
    >
      <div className="tool-header">
        <h3>{tool.name}</h3>
        {isActive && <span className="active-indicator">Active</span>}
      </div>
      <p>{tool.description}</p>
      <div className="tool-actions">
        <button className="btn btn-outline">Details</button>
        {isActive && <button className="btn btn-primary">Launch</button>}
      </div>
    </div>
  );
}